import {
  useAppInsightsContext,
  useTrackEvent as useAITrackEvent,
  useTrackMetric,
} from "@microsoft/applicationinsights-react-js";
import { useAuth } from "contexts/AuthProvider";
import { v4 as uuidv4 } from "uuid";

export enum AI_EVENTS {
  CHANGE_CUSTOMER_CARD_CARD = "change-card-code",
  PAGE_LOAD = "page-load",
  NAVIGATION_CHANGE = "navigation-change",
  API_REQUEST = "api-request",
  API_ERROR = "api-error",
}

export type EventTrackFunction = (
  data?: AiEventData,
  eventId?: string
) => string;

export const useTrackEvent = (
  eventName: AI_EVENTS,
  parameters: Omit<AiEventMetaData, "username"> = {}
): EventTrackFunction => {
  const appInsights = useAppInsightsContext();
  const { username } = useAuth();
  const eventData = { ...parameters, username };

  const onTrack = useAITrackEvent<AiEventMetaData & Partial<AiEventData>>(
    appInsights,
    eventName,
    eventData
  );

  return (additionalData?: AiEventData, eventId?: string): string => {
    const localEventId = eventId || uuidv4();
    if (process.env.REACT_APP_TRACK_EVENT_CONSOLE_OUTPUT === "true") {
      // eslint-disable-next-line no-console
      console.debug(
        `[Track Event] ${eventName} (${localEventId}) - ${JSON.stringify(
          eventData
        )}`,
        {
          ...eventData,
          ...additionalData,
        }
      );
    }
    onTrack({ ...eventData, ...additionalData, localEventId });
    return localEventId;
  };
};

export const useTrackComponent = ({
  componentName,
}: {
  componentName: string;
}): (() => void) => {
  const appInsights = useAppInsightsContext();
  return useTrackMetric(appInsights, componentName);
};
